import { render, staticRenderFns } from "./RelationAdd.vue?vue&type=template&id=3870b16e&scoped=true"
import script from "./RelationAdd.vue?vue&type=script&lang=js"
export * from "./RelationAdd.vue?vue&type=script&lang=js"
import style0 from "./RelationAdd.vue?vue&type=style&index=0&id=3870b16e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3870b16e",
  null
  
)

export default component.exports